import React from 'react'
import { Section } from '../../components'
import { ContactAdminStyled } from './styled'

export class ContactAdminContainer extends React.Component {
  render() {
    return (
      <React.Fragment>
        <ContactAdminStyled className="activate-page">
          <Section className="activate-wrapper">
            <Section className="notification">
              <p>
                Your account registration has been rejected.
                <br />
                Please contact system administrator for information
              </p>
            </Section>
          </Section>
        </ContactAdminStyled>
      </React.Fragment>
    )
  }
}
